export const lg_page404 = {
  page404_th: {
    title: "404",
    title_details: "ไม่พบหน้านี้",
    title_details2: "ไม่พบหน้าที่คุณค้นหา",
    btn: "กลับสู่หน้าหลัก",
  },
  page404_en: {
    title: "404",
    title_details: "Page Not Found",
    title_details2: "We couldn’t find the page you’re looking for.",
    btn: "Back to Home",
  },
};

